<template>
  <div id="jetport">
    <img id="airplanes" src="../assets/airplanes.png" />
    <div id="jetport-text">
      <h3>the battle to defeat the jetport - saving the great swamp</h3>
      <p>“The swamp’s full of scumbags ‘n shiny things with price tags...Everybody's makin' a deal. No, we don't want to fight but we'll stand up for our rights. C Matthew Smith, The Patriot Song 2020</p>
      <p>The New York Port Authority announces plans to pave over The Great Swamp and destroy the area’s communities in order to build the world’s largest regional airport.</p>
    </div>
    <div id="jet-age-text">
      <h5>The Dawn of the 'Jet Age'</h5>
      <p>With the introduction of the Boeing 707 and Douglas DC-8 airliners, air travel, predictions show that 4x the amount of passengers would be traveling through the tri-state area by 1978.</p>
    </div>
    <img id="newspaper" :src="`${path}img/jetportNewspaper.png`" />
    <img id="target" :src="`${path}img/jetportTarget.png`" />
    <img id="landscape-orange" :src="`${path}img/landscapeOrange.png`" />
    <img id="landscape-green" :src="`${path}img/landscapeGreen.png`" />
    <div id="port-authority">
      <h3>$$</h3>
      <p>
        The Port Authority argues that “the jetport would
        <br />bring a tremendous boom in employment and
        <br />business opportunities with thousands of new jobs."
      </p>
    </div>
    <p
      id="grassroots"
    >A Grassroots opposition mobilizes again the NY Port Authority plan. Wealthy local landowners transfer land to the U.S. Dept. of the Interior to become a Wildlife Land Trust to protect the swamp.</p>
    <div class="pointer" />
  </div>
</template>
<script>
import { select } from 'd3'
import _ from 'lodash'

export default {
  name: 'JetportSection',
  props: ['xScale', 'keyDates', 'addScrollTarget'],
  mounted() {
    this.buildContent()
    //this.addScrollTarget('#jetport #airplanes')
  },
  computed: {
    path: () => `${window.location.pathname}`,
  },
  methods: {
    buildContent() {
      select('#jetport')
        .selectAll('.key-date')
        .data(this.keyDates)
        .enter()
        .append('div')
        .attr('class', 'key-date')
        .html(
          d => `<h5 style="color:${_.get(
            d.style,
            'color',
            'var(--key-date-pink)'
          )};">${d.keyDate.title}</h5>
      <p>${d.keyDate.text}</p>`
        )
        .style(
          'left',
          d =>
            `${_.get(d.style, 'left') +
              _.get(d.style, 'adjustHorizontal', 0)}px`
        )
        .style('top', d => `${_.get(d.style, 'top', 100)}px`)
        .style('bottom', d => `${_.get(d.style, 'bottom', 100)}`)
        .style('width', d => `${_.get(d.style, 'width', 400)}px`)
    },
  },
}
</script>
<style>
#jetport {
  position: absolute;
  left: 5425px;
  top: 0px;
  height: 100vh;
  width: 5500px;
}
#jetport img#airplanes {
  position: absolute;
  left: -50px;
  top: -90px;
  opacity: 0;
  animation-name: flyUp;
  animation-delay: 2s;
  animation-duration: 10s;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flyUp {
  0% {
    left: -50px;
    top: -90px;
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  40% {
    opacity: 0.2;
  }
  50% {
    left: 375px;
    transform: scale(1.3);
  }
  60% {
    opacity: 0;
  }
  100% {
    left: 875px;
    transform: scale(1);
  }
}

#jetport-text {
  font-size: 17px;
  line-height: 29px;
  font-weight: 300;
  position: absolute;
  left: 170px;
  top: 170px;
  text-align: left;
}
#jetport .key-date {
  position: absolute;
  left: 1400px;
  top: 50px;
  width: 800px;
  text-align: left;
}
#jetport .key-date h5 {
  color: var(--key-date-pink);
}
#jetport .key-date p {
  width: 500px;
  margin-left: 50px;
}
#jetport #jetport-text h3 {
  font-size: 24pt;
  color: var(--jetport-purple);
}
#jetport #jetport-text p {
  width: 1300px;
  font-size: 17px;
  line-height: 29px;
  //font-weight: 300;
  margin-left: 150px;
  width: 900px;
}
#jetport #jetport-text p:first-of-type {
  font-style: italic;
}
#jetport #jet-age-text {
  font-size: 17px;
  line-height: 29px;
  font-weight: 300;
  position: absolute;
  left: 1400px;
  top: 60px;
  text-align: left;
}
#jetport #jet-age-text h5 {
  font-size: 16pt;
  color: var(--key-date-pink);
}
#jetport #jet-age-text p {
  font-size: 17px;
  line-height: 29px;
  font-weight: 300;
  width: 630px;
}
#newspaper {
  width: 375px;
  left: 1630px;
  top: 200px;
  position: absolute;
}
#target {
  width: 215px;
  left: 2050px;
  top: 200px;
  position: absolute;
}
#landscape-orange {
  width: 225px;
  left: 3000px;
  top: 30px;
  position: absolute;
}
#landscape-green {
  width: 225px;
  left: 2750px;
  top: 30px;
  position: absolute;
}
#port-authority {
  position: absolute;
  left: 2180px;
  top: 60px;
  width: 550px;
  display: flex;
  align-items: flex-start;
  text-align: left;
}
#port-authority h3 {
  font-size: 24pt;
  color: var(--jetport-purple);
}
#port-authority p {
  margin: 0px 20px;
}
#grassroots {
  position: absolute;
  left: 2280px;
  top: 260px;
  width: 350px;
  text-align: left;
}
#jetport .pointer {
  width: 1px;
  background: linear-gradient(orange, white);
  position: absolute;
  bottom: 50%;
  left: 2480px;
  height: 80px;
}
</style>
